import React from "react";

import GeneralAccessManagement from "./GeneralAccess";
import TeamViewManagement from "./View";

// Importing react-redux
import { useSelector, } from 'react-redux';

// Import utilities
import { isAllowedToDo, isAllowedToDoByKey } from "permissions-hub";
import { EMPLOYEE_MANAGEMENT, ACCEPTED_PERMISSIONS } from "constants";
import { isReadOnly } from "validations";
import { getAllowedPermissions } from "utils/authentication";

// Importing common components
import WarningAlert from "common/Alert";

const TeamManagement = ({ permissions }) => {

  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  // Check read permission in Employee Management
  const isAllowedToReadEmployees = isAllowedToDoByKey(
    EMPLOYEE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false,
  );
  
  // Is read-only ?
  const isReadOnlyy = isReadOnly(permissions);

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions
  );

  // Check create permission
  const isAllowedToCreate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["create"],
    permissions
  );

  // Check update permission
  const isAllowedToUpdate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["update"],
    permissions
  );

  // Check delete permission
  const isAllowedToDelete = isAllowedToDo(
    ACCEPTED_PERMISSIONS["delete"],
    permissions
  );

  // Pass TeamViewManagement as a prop if isGeneralAccess is true
  const ManagementComponent = isReadOnlyy ? (
    <TeamViewManagement isAllowedToReadEmployees={isAllowedToReadEmployees} />
  ) : (
    <GeneralAccessManagement
      isAllowedToRead={isAllowedToRead}
      isAllowedToCreate={isAllowedToCreate}
      isAllowedToUpdate={isAllowedToUpdate}
      isAllowedToDelete={isAllowedToDelete}
      TeamViewManagement={TeamViewManagement}
      isAllowedToReadEmployees={isAllowedToReadEmployees}
    />
  );

  return !isAllowedToReadEmployees ? (
    <WarningAlert 
      message="<p>In order to effectively manage the system, you need to have read permissions for <strong>Employee management</strong>. If you are an administrator, you can enable these permissions from the role management section.</p>
      <hr/> <p class='mb-0'>If you need further assistance, please contact the developer at <a href='mailto:ankitbattersea@gmail.com' >ankitbattersea@gmail.com</a>.</p>" 
    />
  ) : (
    ManagementComponent
  );  
};

export default TeamManagement;
